<template>
  <LoadingDiv v-if="!isReady" />

  <template v-else>
    <!-- Search -->

    <!-- Bar -->
    <span class="enrollee-search-shell" v-if="!detailOpen && showSearch && (enrollees.length || searchItem)">
      <nav class="enrollee-search-bar z-depth-0">
        <div class="nav-wrapper">
          <form>
            <div class="input-field blue-text text-darken-2">
              <input
                id="principal-search"
                type="search"
                v-model="searchItem"
                placeholder="Search By Name, ID or Plan"
                autocomplete="off"
              />
              <label class="label-icon" for="principal-search"
                ><i class="material-icons">search</i></label
              >
              <i
                class="material-icons enrollee-search-clear"
                @click="handleClearSearch"
                v-if="searchItem"
                >clear</i
              >
            </div>
          </form>
        </div>
      </nav>
      <!-- Loader -->
      <div class="progress" v-if="isLoading">
        <div class="indeterminate"></div>
      </div>
    </span>

    <!-- Lobby Principals -->
    <LobbyDiv
      :status="status"
      :cat="cat"
      :clientId="clientId"
      :enrollees="enrollees"
      :quote="quote"
      :policy="policy"
      @requote="handleReQuote"
      v-if="displayType == 'p'"
    />

    <!-- Active Principals -->
    <!-- On-Hold Principals -->
    <ActiveHoldDiv
      :authLevel="authLevel"
      :cat="cat"
      :client-name="clientName"
      :enrollees="enrollees"
      :displayType="displayType"
      :policy="policy"
      :server-date="serverDate"
      @reset="handleReset"
      @detail-state="handleDetailState"
      v-if="displayType == 'a' || displayType == 'h' || displayType == 'o'"
    />

    <!-- In-active Principals -->
    <OutDiv
      :cat="cat"
      :enrollees="enrollees"
      @reset="handleReset"
      v-if="displayType == 'd'"
    />

    <template v-if="!isLoading && !detailOpen">
      <div class="section center" v-if="!enrollees.length">
        <h6><img src="@/assets/img/no-user.png" width="256" class="circle responsive-img" /></h6>
      </div>

      <span v-else>
        <PaginationDiv :payLoad="allPages" @newPage="handlePage" />
      </span>
    </template>
  </template>
</template>

  
<script>
import { computed, onMounted, onUpdated, ref, watchEffect } from "vue";
import getItemsOfItems from "@/composables/getItemsOfItems";
import PaginationDiv from "@/components/pager/PaginationDiv.vue";
import LoadingDiv from "@/components/LoadingDiv.vue";
import ActiveHoldDiv from "@/components/client/extras/PrincipalActiveHoldClientComponent.vue";
import LobbyDiv from "@/components/client/extras/PrincipalLobbyClientComponent.vue";
import OutDiv from "@/components/client/extras/PrincipalOutClientComponent.vue";
import M from "materialize-css";

export default {
  name: "EnrolleeClientComponent",
  components: {
    LoadingDiv,
    PaginationDiv,
    ActiveHoldDiv,
    LobbyDiv,
    OutDiv,
  },
  props: ["status", "cat", "authLevel", "clientId", "clientName", "displayType"],
  emits: ["detail-state"],
  setup(props, context) {
    const response = ref(null);
    const utility = ref(null);
    const policyResponse = ref(null);
    const policyServerDate = ref(null);
    const isReady = ref(false);
    const isSubmitting = ref(false);
    const isLoading = ref(false);
    const error = ref(null);
    const currTab = ref([]);
    const tabs = ref([]);
    const currUrl = ref(null);
    const currHook = ref(null);
    const searchItem = ref(null);
    const detailOpen = ref(false);

    // get function
    const getItemsFromApi = (table, id) => {
      (async () => {
        const { res: uRes, err: uErr } = await getItemsOfItems(table, id);
        if (uRes.value) {
          utility.value = uRes.value.data;
        } else {
          error.value = uErr.value;
        }
      })();
    };

    // get function
    const getSearchItemsFromApi = (table, match) => {
      (async () => {
        const { res, err } = await getItemsOfItems(table, match);

        if (res.value) {
          response.value = res.value.data;
        } else {
          error.value = err.value;
        }

        // page is ready, loading is complete
        isReady.value = true;
        isLoading.value = false;
      })();
    };

    // get quote
    const getQuote = () => {
      getItemsFromApi("operator/client/invoice/quote", props.clientId);
    };

    // get current policy
    const getPolicy = () => {
      (async () => {
        const { res, err } = await getItemsOfItems("policy/client", props.clientId);

        if (res.value) {
          policyResponse.value = res.value.data;
          policyServerDate.value = res.value.server;
        } else {
          error.value = err.value;
        }
      })();
    };

    // starter
    onMounted(() => {
      // start from the top
      if (props.displayType == "p") {
        getQuote();
      }

      if (props.displayType == "a" || props.displayType == "h" || props.displayType == "o") {
        getPolicy();
      }
    });

    // starter
    onMounted(() => {
      // loader
      isReady.value = false;
      // start from the top
      getAllUsers(props.displayType);
    });

    // dropdown
    onMounted(() => {
      var elems = document.querySelectorAll(".dropdown-trigger");
      M.Dropdown.init(elems, {});
    });

    // dropdown
    onUpdated(() => {
      var elems = document.querySelectorAll(".dropdown-trigger");
      M.Dropdown.init(elems, {});
    });

    // prinipals
    const getAllUsers = (val) => {
      // set current Url
      currUrl.value = "principal/client/search";
      // set current Hook
      currHook.value = `?z=${val}&`;
      // get items from function
      getSearchItemsFromApi(currUrl.value, `${props.clientId}?z=${val}`);
    };

    // restart
    const handleClearSearch = () => {
      // start laoding
      isLoading.value = true;
      // null search
      searchItem.value = null;
      // start from the top
      getAllUsers(props.displayType);
    };

    // switch page
    const handlePage = (page) => {
      // start laoding
      isReady.value = false;
      // get new page items from function
      getSearchItemsFromApi(
        currUrl.value,
        `${props.clientId}${currHook.value}page=${page}`
      );
    };

    // handle curr status
    const handleActive = (tab) => {
      // update show and components
      currTab.value = tab;
      if (!tab.status) {
        getAllUsers(props.displayType);
      }
    };

    // handle
    const handleReQuote = (val) => {
      // do review
      if (val) {
        getQuote();
        getAllUsers(props.displayType);
      }
    };

    // handle
    const handleReset = (val) => {
      // do review
      let idx;

      if (val) {
        response.value.data.forEach((x, y) => {
          if (x.id == val.id) {
            idx = y;
          }
        });
        // update
        response.value.data[idx] = val;
      }
    };

    const handleDetailState = (val) => {
      detailOpen.value = Boolean(val);
      context.emit("detail-state", val);
    };

    // search watcher
    watchEffect(() => {
      if (searchItem.value && isReady.value) {
        // start laoding
        isLoading.value = true;
        // set current Url
        currUrl.value = "principal/client/search";
        // set current Hook
        currHook.value = `?z=${props.displayType}&q=${searchItem.value}&`;
        // get searchItem items from function
        getSearchItemsFromApi(
          currUrl.value,
          `${props.clientId}?z=${props.displayType}&q=${searchItem.value}`
        );
      } else {
        handleClearSearch();
      }
    });

    // all enrollees
    const enrollees = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value.data;
      }
    });

    // quote
    const quote = computed(() => {
      if (!utility.value) {
        return null;
      } else {
        return utility.value;
      }
    });

    // current policy from quote
    const policy = computed(() => {
      if (utility.value?.policy) {
        return utility.value.policy;
      }

      const policies = Array.isArray(policyResponse.value) ? policyResponse.value : [];
      return (
        policies.find((policy) => policy.status == "a") ||
        policies.find((policy) => policy.status == "p") ||
        policies[0] ||
        null
      );
    });

    const serverDate = computed(() => {
      return policyServerDate.value || utility.value?.server_date || null;
    });

    // output pages
    const allPages = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value;
      }
    });

    // opened all up
    const showSearch = computed(() => {
      if (props.displayType == "p") {
        return false;
      } else {
        return true;
      }
    });

    return {
      handlePage,
      handleActive,
      handleClearSearch,
      handleReQuote,
      handleReset,
      handleDetailState,
      currTab,
      tabs,
      isReady,
      isSubmitting,
      isLoading,
      error,
      searchItem,
      detailOpen,
      quote,
      policy,
      serverDate,
      allPages,
      showSearch,
      enrollees,
    };
  },
};
</script>
  

<style scoped>
.enrollee-search-shell {
  display: block;
  margin-bottom: 14px;
}

.enrollee-search-bar {
  background: #ffffff;
  border: 1px solid #c4d3d9;
  border-radius: 6px;
  box-shadow: 0 14px 24px -28px rgba(38, 50, 56, 0.72);
  height: 58px;
  line-height: 58px;
  overflow: hidden;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease;
}

.enrollee-search-bar:focus-within {
  background: #fbfefe;
  border-color: #00897b;
  box-shadow: 0 16px 28px -24px rgba(0, 105, 92, 0.74);
}

.enrollee-search-bar .nav-wrapper,
.enrollee-search-bar form,
.enrollee-search-bar .input-field {
  height: 100%;
}

.enrollee-search-bar .input-field {
  margin: 0;
}

.enrollee-search-bar input[type="search"] {
  color: #263238;
  font-size: 1rem;
  font-weight: 600;
  height: 58px;
  letter-spacing: 0;
  margin: 0;
  padding-left: 56px;
}

.enrollee-search-bar input[type="search"]::placeholder {
  color: #78909c;
  font-weight: 500;
  opacity: 1;
}

.enrollee-search-bar input[type="search"]:focus {
  background: transparent;
  border-bottom: 0 !important;
  box-shadow: none !important;
}

.enrollee-search-bar .label-icon {
  align-items: center;
  display: flex;
  height: 58px;
  justify-content: center;
  left: 0;
  line-height: 58px;
  width: 56px;
}

.enrollee-search-bar .label-icon i {
  color: #00897b;
  line-height: 58px;
}

.enrollee-search-clear {
  align-items: center;
  background: #fff8e1;
  border: 1px solid #ffd54f;
  border-radius: 50%;
  color: #ef6c00;
  cursor: pointer;
  display: inline-flex !important;
  height: 30px !important;
  justify-content: center;
  line-height: 28px !important;
  margin: 14px 14px 0 0;
  right: 0 !important;
  top: 0 !important;
  width: 30px !important;
}

.enrollee-search-clear:hover {
  background: #ffecb3;
  border-color: #ffb300;
  color: #e65100;
}

.progress {
  margin-top: 0px;
}

.spacer10 {
  margin-top: 10px;
  margin-bottom: 10px;
}

.pointer {
  cursor: default;
}

.edit-item:hover .material-icons.grey-text,
.edit-item:hover .material-icons.grey-text::before {
  color: rgb(21, 21, 206) !important;
}

/* open */
.chip-more {
  cursor: pointer;
  padding-left: 2px;
  padding-right: 2px;
  padding-top: 2px;
  padding-bottom: 2px;
}

.chip-more:hover {
  font-size: 150%;
}

/* close */
.chip-less {
  cursor: pointer;
  color: white !important;
  background-color: black !important;
}

.chip-less:hover {
  color: black !important;
  background-color: #eaecee !important;
}

/* base class */
.tab-custom {
  display: inline-block;
  cursor: pointer;
  margin: 0 0 -1px;
  padding: 10px 15px;
  font-weight: 600;
  text-align: center;
  border: 1px solid transparent;
}

.tab-custom:hover {
  color: #000000 !important;
}

.tab-custom-active {
  display: inline-block;
  cursor: pointer;
  margin: 0 0 -1px;
  padding: 10px 15px;
  color: white;
  font-weight: 600;
  text-align: center;
  background-color: black;
}

/* display */
.tab-custom-section {
  padding: 20px 0 0;
  border-top: 1px solid #ddd;
}
</style>
